import { createContext } from 'react';

const Context = createContext({});
// Add displayName for React dev tools
Context.displayName = 'SearchResultsContext';

export default Context;
